import { createContext, useContext } from 'react';

// What the shell knows about the current page (its navigation group), for primitives rendered inside it.
export const ShellContext = createContext({ section: null });
export const useShell = () => useContext(ShellContext);
